<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { fade } from 'svelte/transition';

  import { AppState, SetIconsBackground } from '../etc/stores';
  import { sleep } from '../etc/utils';

  import Analytics from '../services/analytics';

  import Page from '../components/misc/Page.svelte';
  import Heading from '../components/typography/Heading.svelte';

  import SuccessIcon from '../components/icons/SuccessIcon.svelte';
  import Text from '../components/typography/Text.svelte';
  import { useLocation, useNavigate } from 'svelte-navigator';
  import LoadingIcon from '../components/icons/LoadingIcon.svelte';
  import { replaceVariables } from '../i18n';
  import { Container } from '../services/container';
  import { Customer } from '../services/customer';

  let loading = true;
  let success = false;

  const businessName = $AppState.business.name;

  const navigate = useNavigate();
  const location = useLocation();

  const completeProfileInfomation = $location.state?.completeProfileInfomation;

  const customer = Container.get(Customer) as Customer;

  const t = (text: string, values?: any) => {
    return replaceVariables($_(`soft-login.${text}`), values);
  };

  const onLoad = async () => {
    await sleep(2500);
    loading = false;
    await customer.loadState();

    setTimeout(() => {
      success = true;
    }, 10);
    setTimeout(() => {
      if (completeProfileInfomation) {
        Analytics.logEvent(
          'click-collect-coins-2steps',
          `soft-signup-${Analytics.getCategoryLoginState()}`
        );
        navigate('/account-name', {
          state: {
            hideBackButton: true,
            isEditProfile: true
          }
        });
      } else {
        navigate('/dashboard');
      }
    }, 3000);
  };

  const onChangeShowFooter = show => {
    AppState.update(state => ({
      ...state,
      website: {
        ...state.website,
        footerVisibility: show
      }
    }));
  };

  onDestroy(() => {
    onChangeShowFooter(true);
  });

  onMount(() => {
    SetIconsBackground('light');
    Analytics.logPageView('Soft Login', 'soft-login');
    onLoad();
    onChangeShowFooter(false);
  });
</script>

{#if !success}
  <div class="twism-page" out:fade={{ delay: 2600, duration: 500 }}>
    <Page padding="0 24px 16px">
      {#if loading}
        <div class="soft-login" out:fade={{ duration: 300 }}>
          <div class="soft-login__loading">
            <LoadingIcon />
          </div>
          <Heading
            component="h1"
            type="h1"
            class="soft-login__text"
            textAlign="center"
          >
            {t('loading')}
          </Heading>
        </div>
      {:else}
        <div class="soft-login" in:fade={{ delay: 500, duration: 300 }}>
          <SuccessIcon />
          <Heading
            component="h1"
            type="h1"
            class="soft-login__text"
            textAlign="center"
          >
            {t('success')}
          </Heading>
        </div>
      {/if}
      <div class="soft-login__footer">
        <Text component="p" type="small" color="#012A5A" textAlign="center">
          {@html replaceVariables($_('common.footer'), { businessName })}
        </Text>
      </div>
    </Page>
  </div>
{/if}

<style lang="scss">
  :global(.soft-login__text) {
    font-weight: 500 !important;
    line-height: 33.6px !important;
    margin-top: 24px !important;
    letter-spacing: -0.005em !important;
    max-width: 311px !important;
  }

  .soft-login {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    transform: translateY(-32px);

    &__loading {
      height: 64px;
      width: 64px;
      -webkit-animation: spin 1s linear infinite;
      -moz-animation: spin 1s linear infinite;
      animation: spin 1s linear infinite;
    }

    &__footer {
      opacity: 0.5;
      position: absolute;
      bottom: 16px;
      width: calc(100% - 48px);
    }
  }

  .twism-page {
    z-index: 10;
  }

  @-moz-keyframes spin {
    100% {
      -moz-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>
